// extracted by mini-css-extract-plugin
module.exports = {"kindSelect":"NewCompetition__kindSelect___3oGEW"};